import { request } from '@/api/index';
export function getList(data) {
  return request({
    url: '/api/Template/GetTmps',
    method: 'post',
    data: data
  });
}
export function getShareTmps(data) {
  return request({
    url: '/api/Template/GetShareTmps',
    method: 'post',
    data: data
  });
}
export function updateTmp(data) {
  return request({
    url: '/api/Template/UpdateTmp',
    method: 'post',
    data: data
  });
}
export function createTmp(data) {
  return request({
    url: '/api/Template/CreatTmp',
    method: 'post',
    data: data
  });
}
export function deleteTmp(params) {
  return request({
    url: '/api/Template/DeleteTmp',
    method: 'post',
    params: params
  });
}
export function enableTmp(params) {
  return request({
    url: '/api/Template/EnableTmp',
    method: 'post',
    params: params
  });
}
export function issueTmp(params) {
  return request({
    url: '/api/Template/IssueTmp',
    method: 'post',
    params: params
  });
}
export function shareTmp(params) {
  return request({
    url: '/api/Template/ShareTmp',
    method: 'post',
    params: params
  });
}
export function validTaskTmp(params) {
  return request({
    url: '/api/Template/ValidTaskTmp',
    method: 'get',
    params: params
  });
}
export function getTaskTmp(params) {
  return request({
    url: '/api/Template/GetTmp',
    method: 'get',
    params: params
  });
}